import React, { Component } from "react";
import { connect } from "react-redux";

import LearnMore from "./LearnMore";
import Slider from "./Slider";
import "./styles.css";
import { checkoutData } from "../../../constants/checkoutData";
import CheckoutHeader from "./CheckoutHeader";
import CheckoutStepsList from "./CheckoutStepsList";
import CartNew from "../Cart/CartNew";
import LpCreditCardModal from "../card_modal";
import CheckoutUpsell from "./CheckoutUpsell";
import { getExperimentsData } from "../../../logic/utils/experimentsDataHelpers";

class CheckoutNew extends Component {
  checkoutCoursierData = checkoutData[302];

  state = {
    showPaymentModal: false,
    upsellItems: this.checkoutCoursierData.upsellData,
  };

  componentDidMount() {
    const appBody = document.getElementById("page-checkout");
    if (appBody) {
      appBody.classList.add("app-bg-lightgrey");
    }
  }

  toggleUpsellPrice = () => {
    const updatedUpsellItems = this.state.upsellItems.map(
      (item) => (item = { ...item, isSelected: !item.isSelected })
    );
    this.setState({
      upsellItems: updatedUpsellItems,
    });
  };

  showPaymentModal = () => {
    // Tracking opened payment popup
    const eventParams = {};
    lpevents.trackPopUpCheckout();
    lpevents.track("Opened Payment Popup", eventParams);
    this.setState({ showPaymentModal: true });
  };

  closePaymentModal = () => this.setState({ showPaymentModal: false });

  render() {
    const { customerFirstName = null } = this.props;
    const { showPaymentModal, upsellItems } = this.state;
    const {
      steps,
      contractType,
      checkoutHeaderImg,
      upsellData,
    } = this.checkoutCoursierData;
    const firstName = customerFirstName ? ` ${customerFirstName}` : "";

    return (
      <div className="checkoutNew-container">
        <div className="checkoutNew-recap-container">
          <CheckoutHeader
            checkoutHeaderImg={checkoutHeaderImg}
            customerFirstName={firstName}
            contractType={contractType}
          />
          <CheckoutStepsList checkoutSteps={steps} />
        </div>
        {upsellData.map((upsell, index) => {
          return (
            <CheckoutUpsell
              addUpsellPrice={this.toggleUpsellPrice}
              upsellData={upsell}
              key={`upsell_${index + 1}`}
            />
          );
        })}
        <CartNew upsellItems={upsellItems} />
        {/* TODO make all this data specific to each contract by adding it to the checkout data object */}
        <LearnMore />
        <Slider />
        <div className="footer">
          <p>
            Nous nous occupons de toutes les démarches administratives pour vous
            permettre de devenir micro-entrepreneur et commencer votre activité
            de coursier à vélo.
          </p>
          <p>
            Notre expertise permet de garantir que vous obtiendrez votre Kbis
            dans les meilleurs délais et que votre dossier est garanti valide et
            conforme.
          </p>
        </div>
        <LpCreditCardModal
          show={showPaymentModal}
          closeEvent={this.closePaymentModal}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  customerFirstName: state.loadedOvc.v["30"],
});

export default connect(mapStateToProps)(CheckoutNew);



// WEBPACK FOOTER //
// ./src/components/buy/Checkout/CheckoutNew.js